module.exports = __webpack_public_path__ + "static/images/2ac5f0dd.png";